import {
  AirPriceFreezeSelectors,
  type AirPriceFreezeMachineContext,
  AirPriceFreezePurchaseState,
  getParentState,
} from "@hopper-b2b/checkout";
import type { State } from "xstate";

type StateType = State<AirPriceFreezeMachineContext>;
export const Selectors = {
  ...AirPriceFreezeSelectors,
  isOnFulfillFailedState: (state: StateType) =>
    getParentState(state.value) === AirPriceFreezePurchaseState.fulfillFailed,
};
